import React from 'react';
import {Link} from 'react-router-dom';
import {bankDetails, storeWishlists} from '../data/gift-registry-data';

const GiftRegistryPage: React.FC = () => {
    return (
        <>
            <div
                className="relative min-h-screen bg-gradient-to-b from-black via-[var(--primary-color)] to-black text-white flex flex-col items-center justify-center p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden">
                {/* Header Image */}
                <div className="absolute top-0 left-0 w-full h-48 sm:h-56 md:h-64 lg:h-80 overflow-hidden opacity-30">
                    <img
                        src="/images/gift-registry.jpg"
                        alt="Mesa de Regalos"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black"></div>
                </div>

                <div className="relative z-10 max-w-6xl w-full text-center">
                    <h1 className="font-erotica text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-6 sm:mb-8 mt-16 sm:mt-20">Mesa
                        de Regalos</h1>
                    <p className="text-lg mb-8 leading-relaxed">
                        Tu presencia en nuestra boda es el regalo más valioso que podríamos recibir. Sin embargo, si
                        deseas contribuir a nuestro nuevo hogar, hemos preparado estas opciones para tu comodidad.
                    </p>

                    {/* Priority Section - Money Gifts */}
                    <div className="mb-12">
                        <div
                            className="bg-gradient-to-r from-amber-900/40 to-yellow-800/40 p-6 sm:p-8 rounded-lg border-2 border-amber-600/50 mb-8">
                            <h2 className="font-elza-medium text-2xl sm:text-3xl mb-6 text-amber-200">💰 Nuestra
                                Preferencia</h2>
                            <p className="text-lg mb-6 text-gray-200">
                                Si deseas hacer un regalo, apreciamos mucho las contribuciones monetarias que nos
                                ayudarán a construir nuestro futuro juntos.
                            </p>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* Envelope Option */}
                                <div className="bg-gray-900/50 p-6 rounded-lg border border-amber-600/30">
                                    <div className="text-4xl mb-4">💌</div>
                                    <h3 className="font-elza-medium text-xl mb-3 text-amber-200">Sobre en la
                                        Celebración</h3>
                                    <p className="text-sm text-gray-300">
                                        Puedes entregar tu regalo en un sobre directamente en la recepción. Habrá una
                                        mesa especial para este propósito.
                                    </p>
                                </div>

                                {/* Transfer Option */}
                                <div className="bg-gray-900/50 p-6 rounded-lg border border-amber-600/30">
                                    <div className="text-4xl mb-4">🏦</div>
                                    <h3 className="font-elza-medium text-xl mb-3 text-amber-200">Transferencia
                                        Bancaria</h3>
                                    <p className="text-sm text-gray-300 mb-4">
                                        Para tu comodidad, también puedes realizar una transferencia bancaria:
                                    </p>
                                    <div className="bg-black/30 p-4 rounded text-left text-sm font-mono">
                                        <p><strong>Banco:</strong> {bankDetails.bank}</p>
                                        <p><strong>Cuenta:</strong> {bankDetails.account}</p>
                                        <p><strong>CLABE:</strong> {bankDetails.clabe}</p>
                                        <p><strong>Titular:</strong> {bankDetails.holder}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Secondary Section - Store Wishlists */}
                    <div className="mb-12">
                        <h2 className="font-elza-medium text-2xl sm:text-3xl mb-8">🛍️ Lista de Deseos</h2>
                        <p className="text-lg mb-8 text-gray-300">
                            Si prefieres obsequiar algo específico, hemos creado listas de deseos en algunas tiendas.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {storeWishlists.map((store) => (
                                <div key={store.name}
                                     className="bg-gray-900/30 p-6 rounded-lg border border-gray-800 flex flex-col">
                                    <div className="text-3xl mb-4">{store.icon}</div>
                                    <h3 className="font-elza-medium text-xl mb-3">{store.name}</h3>
                                    <p className="text-sm text-gray-300 mb-4 flex-grow">
                                        {store.description}
                                    </p>
                                    {store.link && store.link !== '#' ? (
                                        <a
                                            href={store.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="font-elza-medium text-sm bg-white/20 hover:bg-white/30 px-4 py-2 rounded transition-colors inline-block mt-auto"
                                        >
                                            Ver Lista →
                                        </a>
                                    ) : (
                                        <span
                                            className="font-elza-medium text-sm bg-gray-500/20 text-gray-400 px-4 py-2 rounded inline-block cursor-not-allowed mt-auto">
                                            Próximamente
                                        </span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Thank You Section */}
                    <div className="bg-gray-900/50 p-6 rounded-lg border border-gray-800 mb-12">
                        <h2 className="font-elza-medium text-2xl mb-4">💕 Agradecimiento</h2>
                        <p className="text-base text-gray-300">
                            Recordamos que lo más importante para nosotros es compartir este momento especial contigo.
                            Tu presencia y buenos deseos son los regalos más preciados que podríamos recibir.
                        </p>
                    </div>

                    <Link to="/"
                          className="font-elza-medium text-lg border-b-2 border-white hover:text-gray-300 hover:border-gray-300 transition mt-12 inline-block">
                        Volver al inicio
                    </Link>
                </div>
            </div>
        </>
    );
};

export default GiftRegistryPage;